<template>
  <div class="add-buyer">
    <b-row>
      <b-col :lg="8">
        <h1 class="page-title section-title title-slash mb-5">
          {{ $t('buyers.add.title') }}
        </h1>
      </b-col>
      <b-col :lg="8" class="scale-down">
        <steps :step="step" />
      </b-col>
    </b-row>
    <samples
      v-if="step === 1"
      @loadBuyer="loadBuyer"
      @nextStep="step++"
      :uploads="uploads"
      @updatedUploads="updatedUploads"
      :buyer="buyer"
    />
    <information
      v-if="step === 2"
      @loadBuyer="loadBuyer"
      @nextStep="step++"
      @prevStep="step--"
      :form="form"
      :buyer="buyer"
    />
    <business
      v-if="step === 3"
      @loadBuyer="loadBuyer"
      @prevStep="step--"
      :form="form"
      :buyer="buyer"
    />
  </div>
</template>
<script>
import Information from '@/components/buyers/Information'
import Business from '@/components/buyers/Business'
import Samples from '@/components/buyers/Samples'
import Steps from '@/components/buyers/Steps'
import buyersService from '@/services/buyers'

export default {
  data() {
    return {
      step: 1,
      buyer: {},
      uploads: [],
      form: {
        drip_limit: '',
        country: '',
        name: '',
        address: '',
        payment_days: '',
        payment_tenor: '',
        years_selling: '',
        currency: '',
        routing: '',
        docs_release: ''
      }
    }
  },
  mounted() {
    document.title = this.$t('buyers.add.htmlTitle')
  },
  methods: {
    loadBuyer() {
      return buyersService
        .fetchBuyersDetails(this.$route.params.buyerId, {
          include: ['customer_task_flows', 'buyer_form_data']
        })
        .then((res) => {
          this.buyer = {
            customer_task_flows: res.data.customer_task_flows,
            buyer_form_data: res.data.buyer_form_data
          }
          this.form = res.data.buyer_form_data || this.form
          return this.updateUploads()
        })
    },
    updateUploads() {
      return this.buyer.customer_task_flows[0].documents.map((document) => {
        return this.uploads.indexOf(document.tags) === -1
          ? this.uploads.push(document.tags)
          : false
      })
    },
    updatedUploads(key) {
      return this.uploads.indexOf(key) === -1 ? this.uploads.push(key) : false
    }
  },
  components: {
    Information,
    Business,
    Samples,
    Steps
  }
}
</script>
